export default [
  {
    title: 'breadcrumb.baccaratLive',
    route: 'baccarat-live',
    icon: '',
    resource: 'baccarat-live',
    action: 'read',
  }
];